export const MY_CLAIMS_PAGES = {
  BENEFIT_QUOTES: {
    LANDING: 'Benefit quotes',
    GET_A_BENEFIT_QUOTE: 'Get a benefit quote',
    RESULT: 'Benefit quote #',
  },
  CLAIMS: {
    LANDING: 'Claims',
    MAKE_A_CLAIM: 'Make a claim',
    RESULT: 'Claim #',
    RESULT_KEEP_PRIVATE: 'Claim submitted',
  },
  LIMITS_USAGE: {
    LANDING: 'Limits and usage',
  },
  SNAP_AND_SEND: {
    LANDING: 'Snap and send',
    RESULT: 'Snap and send confirmation',
  },
};

export const MY_COVER = {
  REBATE_NOMINATION: {
    LANDING: 'Rebate nomination',
    UPDATE_TIER: 'Update rebate tier',
    PREMIUM_IMPACT: 'Rebate premium impact',
  },
  PREMIUM_CALCULATOR: 'Premium calculator',
  PAYMENTS: {
    LANDING: 'Premium Activity',
    MAKE_A_PAYMENT: 'Make a payment',
    PAYMENT_SUCCESSFUL: 'Payment successful',
  },
  TAX_STATEMENTS: {
    LANDING: 'Tax statements',
  },
  MY_DOCUMENTS: {
    LANDING: 'My documents',
  },
  WAITING_PERIOD: {
    LANDING: 'Waiting periods',
  },
  CHANGE_COVER: {
    LANDING: 'Change my cover',
    CHANGE_MY_PRODUCT: 'Change my product',
    ADD_REMOVE_PERSON: 'Add or remove person',
  },
  CHANGE_EXCESS: {
    LANDING: 'Change my excess',
    PREMIUM_IMPACT: 'Your excess update was successful',
  }
};

export const MEMBER_MENU = {
  MEMBER_DETAILS: {
    MEMBER_SELECTION: 'Member details',
    NO_IMPACT: 'Your update has been made',
    PREMIUM_IMPACT: 'Details successfully updated',
  },
  MEMBER_CARD: {
    REQUEST: 'Order a member card',
    SUCCESS: 'Request success',
  },
  PAYMENT_DETAILS: {
    LANDING: 'Payment details',
    VIEW_UPDATE_DETAILS: 'Manage your premium payments',
    RESULT: 'Payment details successfully updated',
  },
};

export const NON_NAV_PAGES = {
  LEGAL: 'Legal',
  SEARCH: 'Search',
};
